import { useEffect, useState } from "react";
import { ClienteContext } from "./ClienteContext";

export const ClienteState = (props) => {
    const [cliente, setCliente] = useState(null);
    const [actualizar, setActualizar] = useState(false);

    useEffect(() => {
        Lista();
    }, []);

    const Lista = async () => {
        try {

        } catch (error) {
            console.error("Error al obtener productos o servicios:", error);
        }
    };
    return (
        <ClienteContext.Provider
            value={{
                cliente,
                actualizar,

                setActualizar,
                setCliente,
                Lista,
            }}
        >
            {props.children}
        </ClienteContext.Provider>
    );
    
};
